import React from "react";
import "./Birthdays.css";
import DateToday from "./DateToday";
import DateTomorrow from "./DateTomorrow";
import TodayBirthdays from "./TodayBirthdays";
import TomorrowBirthdays from "./TomorrowBirthdays";
import "./Wishes.css";

const Wishes = () => {
  return (
    <div className="wishes">
      <div className="element">
        <h2 className="title">
          Birthdays On <span className="sm-display-date">Today</span>
          <DateToday />
        </h2>
        <div className="today">
          <TodayBirthdays />
        </div>
      </div>
      <div className="element">
        <h2 className="title">
          Birthdays On <span className="sm-display-date">Tomorrow</span>
          <DateTomorrow />
        </h2>
        <div className="tomorrow">
          <TomorrowBirthdays />
        </div>
      </div>
    </div>
  );
};

export default Wishes;
